import React from 'react';
import { TutorsSearchBox } from '../../components/TutorsSearchBox';
import { LoggedInLayoutSelector } from '../../Layouts/LoggedInLayoutSelector';
import { VerifyUser } from './VerifyUser';

export function TutorsList() {
    return (
        <LoggedInLayoutSelector>
            <VerifyUser />
            <div className="main-bg pt-[60px] pb-0">
                <TutorsSearchBox />
                {/*<div className='flex max-w-[950px] p-4 mx-auto bg-white border border-t-0 border-b-0'>*/}
                {/*    <TutorsSearchBox />*/}
                {/*</div>*/}
            </div>
         
           
        </LoggedInLayoutSelector>
    );
}